<script setup lang="ts">
import type { ReadonlyDeep } from 'type-fest';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { reactive, watch } from 'vue';

import DetailedJobChip from '@/components/chips/DetailedJobChip.vue';

export interface Props {
  job?: ReadonlyDeep<
    Pick<openapi.JobDetailedOpenapi, 'is_priority' | 'is_rfc'>
  >;
  attachments?: ReadonlyDeep<openapi.JobDetailedOpenapi['attachments']>;
}
const props = withDefaults(defineProps<Props>(), {
  job: undefined,
  attachments: undefined,
});

interface Chips {
  Priority?: boolean;
  Attachments?: boolean;
  Checklist?: boolean;
  'Request for change'?: boolean;
  Attributes?: boolean;
  Locked?: boolean;
}

const chips = reactive<Chips>({});

// TODO chips: Checklist, Attributes, Locked

watch([() => props.job?.is_priority], (newValue, oldValue) => {
  if (props.job?.is_priority) {
    chips.Priority = true;
  } else {
    chips.Priority = false;
  }
});
watch([() => props.job?.is_rfc], (newValue, oldValue) => {
  if (props.job?.is_rfc) {
    chips['Request for change'] = true;
  } else {
    chips['Request for change'] = false;
  }
});
watch(
  [() => props.attachments],
  (newValue, oldValue) => {
    if (props.attachments?.length) {
      chips.Attachments = true;
    } else {
      chips.Attachments = false;
    }
  },
  { deep: true },
);
</script>

<template>
  <ul
    :class="$style.detailedJobAppBarChipsBasicList"
    data-testid="detailedJobAppBarChipsBasicList"
  >
    <li v-if="chips.Priority">
      <DetailedJobChip :class="$style.chip" :color="$style.redColor">
        Priority
      </DetailedJobChip>
    </li>
    <li v-if="chips.Attachments">
      <DetailedJobChip :class="$style.chip">Attachments</DetailedJobChip>
    </li>
    <li v-if="chips.Checklist">
      <DetailedJobChip :class="$style.chip">Checklist</DetailedJobChip>
    </li>
    <li v-if="chips['Request for change']">
      <DetailedJobChip :class="$style.chip">
        Request for change
      </DetailedJobChip>
    </li>
    <li v-if="chips.Attributes">
      <DetailedJobChip :class="$style.chip">Attributes</DetailedJobChip>
    </li>
    <li v-if="chips.Locked">
      <DetailedJobChip :class="$style.chip" :color="$style.orangeColor">
        Locked
      </DetailedJobChip>
    </li>
  </ul>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

:export {
  redColor: colors.$color-red-500;
  orangeColor: colors.$color-yellow-500;
}

.detailedJobAppBarChipsBasicList {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  margin-left: 6px;
}
  .chip {
    margin: 2px;
  }
</style>
